export default __webpack_public_path__ + "static/media/export.0ff9cd20.svg";